<!-- 缴费接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/comUpwardStructureForThirdPark"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
          "parkCode": "2KM43Y461",
          "channelSeq": "0001",
          "userUniqCode": "1231231231"
        },
        responseCode: {
          "data": {
            "selfInRandomCode": "",
            "selfOutRandomCode": "",
            "parkCode": "",
            "channelId": "",
            "passType": "",
            "isParkInOut": "",
            "isPaid": "",
            "code": "",
            "msg": "",
            "parkingCode": "",
            "amount": "",
            "carNo": ""
          },
          "message": "业务成功",
          "resultCode": 0,
          "status": 1
        },
        infoData: {
          explain: "智慧停车开放平台主动向第三方停车场获取离场通道当前车辆的随机码及车牌，车辆自助离场",
          sdkcondition: "cmd=scanChannelQrCodeOutForThi",
          httpcondition: this.commonUrls.third+"scanChannelQrCodeOutForThi",
          precondition: "无",
          fitSystem: "第三方停车场",
          pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
          frequency:"实时触发",
          Q_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'parkCode', info2: '否', info3: 'String', info4: '停车场编号' },
              { info1: 'channelId', info2: '是', info3: 'String', info4: '离场通道ID，停车场方自有的通道ID' },
              { info1: 'userUniqCode', info2: '是', info3: 'String', info4: '第三方所属用户的唯一编码' },
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'selfInRandomCode', info2: '是', info3: 'String', info4: '自助进场随机码' },
              { info1: 'selfOutRandomCode', info2: '是', info3: 'String', info4: '自助离场随机码' },
              { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
              { info1: 'channelId', info2: '是', info3: 'String', info4: '通道ID，停车场方自有的通道ID' },
              { info1: 'isParkInOut ', info2: '是', info3: 'Integer', info4: '是否整个停车场 0：否 1：是' },
              { info1: 'isPaid', info2: '是', info3: 'Integer', info4: '是否已付费 0:否 1：是' },
              { info1: 'code', info2: '是', info3: 'Integer', info4: '返回码 0:成功 1:匹配不到进场随机码 2:匹配不到离场随机码 3:未缴费 4:找不到指定的自助码 5:开闸失败 6:已存在关联的自助进场记录 7:找不到指定的停车场 8:当前通道没有车辆 9:查费失败 10:当前通道没有开启自助开闸功能' },
              // { info1: 'msg', info2: '是', info3: 'String', info4: '返回消息' },
              { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车唯一编码（在进场通道处调用该接口，字段为空）' },
              { info1: 'amount', info2: '否', info3: 'Decimal', info4: '需缴费金额，单位：元' },
              { info1: 'carNo', info2: '否', info3: 'String', info4: '车牌号码，当前触发车辆为有牌车两且能匹配上进场记录时必填y' },
            ]
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
            td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/thirdParkForAke/common/scanChannelQrCodeOutForThi.vue